

import { CustomMenu } from '@ilinium/shared/src/common/domain/modelos/menu/CustomMenu';
import store from '@ilinium/shared/src/common/infrastructure/almacen';
import { computed, defineComponent, onMounted, ref } from 'vue';
import { searchMenuTree } from '../../../../../menu/infrastructure/HelperMenu';

export default defineComponent({
    name: 'customredirectcontrol',
    props: {
        data: Object
    },
    setup(props) {

        const selectedData = ref();
        const cusMenu = store.getters.getApplicationMenus as CustomMenu[];




       

        const getPathFromChildMenu = (menuCustom: CustomMenu, newPath: string | null): string | null => {

            const label = menuCustom.label as string;

            if (newPath == null) {
                newPath = label;
            }
            else {
                newPath = label + ' --> ' + newPath;
            }

            if (menuCustom.parentId) {
                const parent = searchMenuTree(cusMenu, menuCustom.parentId);
                if (parent != null) {
                    return getPathFromChildMenu(parent, newPath);
                }
            }

            return newPath;

        }


        const getAllMenu = (data: CustomMenu[]) => {

            let extractedItems: CustomMenu[] = [];

            for (const element of data) {

                extractedItems.push(element);

                if (element.items && element?.items.length > 0) {

                    const subItems = getAllMenu(element.items as CustomMenu[]);
                    extractedItems = extractedItems.concat(subItems);
                }
            }

            return extractedItems;

        };

        const getMenuWithPath = () => {

            var data = getAllMenu(cusMenu);

            var menu = data.map(x => ({
                id: x.id,
                label: x.label,
                path: getPathFromChildMenu(x, null),
                parentId: x.parent

            })).sort((a, b) => { return (a.parentId ?? 0) - (b.parentId ?? 0); }) as any[]


            return menu;

        };




        onMounted(() => {
            if (props.data) {
                selectedData.value = props.data.value;
            }
        })

        return {
            selectedData,
            getMenuWithPath


        };
    },
});
